// extracted by mini-css-extract-plugin
export default {"pageContainer":"ContactsPage_pageContainer__GBP1h","container":"ContactsPage_container__o1riW"};